import React, { useEffect, useState } from "react";
import App from "./App";
import LevelMaker from "./pages/LevelMaker";
import PlayLevel from "./pages/PlayLevel";
import Play from "./pages/Play";

export default function Router() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  if (path === "/maker") return <LevelMaker />;
  if (/^\/play\/[^/]+\/[^/]+$/.test(path)) return <PlayLevel />;
  if (/^\/play\/?$/.test(path)) return <Play />;
  return <App />;
}
